import "../designSystem/design.css";

export const CardWithTitle = ({ title, children, variant = "primary", className }) => {
    return (
        <div
            className={`card-container ${variant === "primary" ? "primary-box" : "secondary-box"} ${className}`}
        >
            <h5 className={`card-title ${variant}`}>{title}</h5>
            {children}
        </div>
    );
};